import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      Made with ❤️ By Mrutyunjay Dash
    </footer>
  );
};

export default Footer;
